import { useState, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import CategoryTabs from '@/components/feature/CategoryTabs';
import MovieCard from '@/components/feature/MovieCard';
import { categories, getMoviesByCategory } from '@/mocks/movies';

const categoryNames: Record<string, string> = {
  action: '动作', comedy: '喜剧', romance: '爱情', scifi: '科幻',
  horror: '恐怖', animation: '动画', drama: '剧情', suspense: '悬疑',
  documentary: '纪录片',
};

export default function Category() {
  const { category } = useParams<{ category: string }>();
  const [activeCategory, setActiveCategory] = useState(category || 'action');

  useEffect(() => {
    if (category) setActiveCategory(category);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [category]);

  const catName = categoryNames[activeCategory] || activeCategory;
  const filteredMovies = useMemo(() => getMoviesByCategory(activeCategory), [activeCategory]);

  const handleCategoryChange = (catId: string) => {
    if (catId === 'all') {
      window.location.href = '/';
      return;
    }
    window.history.pushState(null, '', `/category/${catId}`);
    setActiveCategory(catId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Breadcrumb />

      <section className="w-full px-4 md:px-6 py-6 md:py-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              {catName}影视
            </h1>
            <p className="text-sm text-foreground-400">
              天美影视为您精选{catName}类影视作品，高清免费在线观看，不缓冲不卡顿流畅追剧体验
            </p>
          </div>

          <CategoryTabs activeCategory={activeCategory} onCategoryChange={handleCategoryChange} />

          <div className="mt-6">
            <div className="flex items-center justify-between mb-4">
              <span className="text-sm text-foreground-400">
                共 {filteredMovies.length} 部作品
              </span>
            </div>
            {filteredMovies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
                {filteredMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-movie-line text-2xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-400">该分类暂无内容</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}